(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState;
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            /**
   * Returns the current game board state.
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game score.
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * Returns the current game status.
   * @returns {string}
   */ /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.resetBoard();
                this.addRandomTile();
                this.addRandomTile();
                this.status = "playing";
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.move(function(row) {
                    return row;
                }, function(row) {
                    return row;
                });
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.move(function(row) {
                    return row.reverse();
                }, function(row) {
                    return row.reverse();
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.moveTranspose(function(row) {
                    return row;
                }, function(row) {
                    return row;
                });
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.moveTranspose(function(row) {
                    return row.reverse();
                }, function(row) {
                    return row.reverse();
                });
            }
        },
        {
            key: "resetBoard",
            value: function resetBoard() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                this.board.forEach(function(row, i) {
                    row.forEach(function(cell, j) {
                        if (cell === 0) emptyCells.push([
                            i,
                            j
                        ]);
                    });
                });
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), x = _emptyCells_Math_floor[0], y = _emptyCells_Math_floor[1];
                    this.board[x][y] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            /**
   * Moves and merges the tiles.
   * @param {Function} processRow
   * @param {Function} unprocessRow
   */ key: "move",
            value: function move(processRow, unprocessRow) {
                var _this = this;
                var moved = false;
                var newBoard = this.board.map(function(row, rowIndex) {
                    var processedRow = processRow((0, $227c6742e0ff6f82$export$71511d61b312f219)(row));
                    var mergedRow = _this.mergeRow(processedRow);
                    if (!_this.rowsEqual(processedRow, mergedRow)) moved = true;
                    return unprocessRow(mergedRow);
                });
                if (moved) {
                    this.board = newBoard;
                    this.addRandomTile();
                }
                this.updateStatus();
            }
        },
        {
            /**
   * Moves tiles along a transposed version of the board.
   * @param {Function} processRow
   * @param {Function} unprocessRow
   */ key: "moveTranspose",
            value: function moveTranspose(processRow, unprocessRow) {
                this.board = this.transpose(this.board);
                this.move(processRow, unprocessRow);
                this.board = this.transpose(this.board);
            }
        },
        {
            /**
   * Merges a single row and returns the new row.
   * @param {number[]} row
   * @returns {number[]}
   */ key: "mergeRow",
            value: function mergeRow(row) {
                var merged = [];
                var skip = false;
                for(var i = 0; i < row.length; i++){
                    if (skip) {
                        skip = false;
                        continue;
                    }
                    if (row[i] !== 0 && row[i] === row[i + 1]) {
                        merged.push(row[i] * 2);
                        this.score += row[i] * 2;
                        skip = true;
                    } else if (row[i] !== 0) merged.push(row[i]);
                }
                while(merged.length < 4)merged.push(0);
                return merged;
            }
        },
        {
            /**
   * Transposes a 2D array (flips rows and columns).
   * @param {number[][]} matrix
   * @returns {number[][]}
   */ key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(rowIndex, colIndex) {
                    return matrix.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            /**
   * Checks if two rows are equal.
   * @param {number[]} row1
   * @param {number[]} row2
   * @returns {boolean}
   */ key: "rowsEqual",
            value: function rowsEqual(row1, row2) {
                return row1.every(function(value, index) {
                    return value === row2[index];
                });
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.board.flat().includes(2048)) this.status = "win";
                else if (!this.board.flat().includes(0) && !this.canMakeMove()) this.status = "lose";
            }
        },
        {
            /**
   * Checks if any move is possible.
   * @returns {boolean}
   */ key: "canMakeMove",
            value: function canMakeMove() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (i > 0 && this.board[i][j] === this.board[i - 1][j] || j > 0 && this.board[i][j] === this.board[i][j - 1]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
function $197cd56b15c33885$var$renderGame() {
    var state = $197cd56b15c33885$var$game.getState();
    var cells = document.querySelectorAll(".field-cell");
    state.flat().forEach(function(cellValue, index) {
        var cell = cells[index];
        cell.textContent = cellValue || "";
        cell.className = "field-cell";
        if (cellValue) cell.classList.add("field-cell--".concat(cellValue));
    });
    var scoreDisplay = document.querySelector(".game-score");
    scoreDisplay.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        document.querySelector(".message-win").classList.remove("hidden");
        document.querySelector(".message-lose").classList.add("hidden");
    } else if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        document.querySelector(".message-lose").classList.remove("hidden");
        document.querySelector(".message-win").classList.add("hidden");
    } else {
        document.querySelector(".message-win").classList.add("hidden");
        document.querySelector(".message-lose").classList.add("hidden");
    }
}
function $197cd56b15c33885$var$startOrRestartGame() {
    var startButton = document.querySelector(".start") || document.querySelector(".restart");
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    startButton.textContent = "Restart";
    startButton.classList.remove("start");
    startButton.classList.add("restart");
    document.querySelector(".message-start").classList.add("hidden");
    $197cd56b15c33885$var$renderGame();
}
function $197cd56b15c33885$var$handleKeyPress(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderGame();
}
document.querySelector(".start").addEventListener("click", $197cd56b15c33885$var$startOrRestartGame);
document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyPress);
$197cd56b15c33885$var$renderGame();

})();
//# sourceMappingURL=index.68e7686e.js.map
